module.exports = __webpack_public_path__ + "img/c8.7a6160ae.jpg";